export const TYPES = {
  EVENTS: 'FILTERS_TYPES_EVENTS',
  PUBLICATIONS: 'FILTERS_TYPES_PUBLICATIONS',
  NEWS: 'FILTERS_TYPES_NEWS',
  STARTUP: 'FILTERS_TYPES_STARTUP',
  AUDIOS: 'FILTERS_TYPES_AUDIOS',
  COMMUNICATION: 'FILTERS_TYPES_COMMUNICATION',
  INFOGRAPHICS: 'FILTERS_TYPES_INFOGRAPHICS',
  PHOTOS: 'FILTERS_TYPES_PHOTOS',
  RELEASES: 'FILTERS_TYPES_RELEASES',
  VIDEOS: 'FILTERS_TYPES_VIDEOS',
  INNOVATIONS: 'FILTERS_TYPES_INNOVATIONS',
};
